import { URLQueries } from './url_query'

/**
 * 获取算法事件参数
 * @return {Object}
 */
export const getEventParams = () => {
  const query = URLQueries.getQuery('eventParams')
  if (!query) return {}
  return query.split('|').reduce((prev, curr) => {
    const [key, value] = curr.split(':')
    return Object.assign(prev, {
      [key]: value,
    })
  }, {})
}
